<ion-header>
  <ion-toolbar>
    <ion-title>Countries</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar placeholder="Search" (ionInput)="getItems($event)"></ion-searchbar>
  <ion-list>
    <ion-item *ngFor="let country of countries" (click)="close(country.country_code, country.name)">
      <ion-label>{{ country.name }} ({{ country.country_code }})</ion-label>
    </ion-item>
  </ion-list>

</ion-content>